import { useContext } from 'react';

import { SourceMediaTracksContext } from 'features/source-media-tracks/contexts';

export const useSourceMediaTracksContext = () => {
  return useContext(SourceMediaTracksContext);
};
